import { Accordion, Form, Button } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { API_URL } from "../../services/api";
import { useCookies } from "react-cookie";
import toast, { Toaster } from "react-hot-toast";
import EditableInput from "./acordionComponent/EditableInput";
import AcordionFormConfig from "./acordionComponent/AcordionFormConfig";
import AcordionItems from "./acordionComponent/AcordionItems";
import Key from "../../util/Key";
import { save, edit_config, save_input } from "./Service";
import { handleChange } from "./util";

const Acordion = ({
    inputs,
    companies,
    dataInput,
    setDataInput,
    dataSelect,
    setDataSelect,
    editableInput,
    setEditableInput,
    itemEditable,
    setItemEditable,
    create,
    form,
    setForm,
    edit = false,
    replyTo,
    setReplyTo,
    slug,
}) => {
    const [formConfig, setFormConfig] = useState({
        description: "Formulario de contacto",
        title: "Contáctanos",
        head: "Ingresa tus datos de contácto",
        footer: "Te responseremos a la brevedad",
        thank_contact: "",
        content_thank_contact: "",
        later_contact: "",
        content_later_contact: "",
        later_time: "",
        confirmation_message: "",
        content_confirmation_message: "",
        error_message: "",
        content_error_message: "",
        style: "none",
    });

    const [newInput, setNewInput] = useState({
        label: "",
        placeholder: "",
        required: 0,
        error: 0,
        error_message: "",
        color: "",
        size: 0,
        reply_to: 0,
    });
    const [token, setToken] = useCookies(["token"]);
    const [mails, setMails] = useState([]);
    const [requiredInput, setRequiredInput] = useState(0);
    const [errorMessage, setErrorMessage] = useState(0);
    const [editFormConfig, setEditFormConfig] = useState(false);

    useEffect(() => {
        if (form) {
            setMails(form.sendMailsArray);
        }
        dataInput;
    }, []);

    useEffect(() => {
        dataInput.length &&
            dataInput.map((item) => {
                if (edit) {
                    if (item.reply_to) {
                        setReplyTo(1);
                    }
                } else {
                    if (item.data.reply_to) {
                        setReplyTo(1);
                    }
                }
            });
    }, [dataInput]);

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();

    const getChange = (event) => {
        handleChange(
            event,
            setRequiredInput,
            setErrorMessage,
            newInput,
            setNewInput
        );
    };

    const submit = (event) => {
        if (newInput.label === "") {
            toast.error("Complete datos");
        } else {
            if (
                newInput.type === "select" &&
                newInput.selectedDataArray.length === 0
            ) {
                toast.error("Selector sin campos");
            } else {
                if (edit) {
                    setDataInput([...dataInput, newInput]);
                    createInput(newInput);
                } else {
                    setDataInput([...dataInput, { data: newInput }]);
                }
                setNewInput({
                    label: "",
                    placeholder: "",
                    required: "0",
                    error: "0",
                    error_message: "",
                    color: "",
                    size: 0,
                    reply_to: 0,
                });
            }
        }
        event.preventDefault();
        event.target.reset();
    };

    const createInput = async (newInput) => {
        const res = await save_input(slug, newInput, token);
        if (res.success) {
            toast.success(res.message);
        } else {
            toast.error(res.message);
        }
    };

    //Register data for formConfig
    const submitFormConfig = (data, e) => {
        setFormConfig({
            ...formConfig,
            company_id: data.company_id,
            send_to: mails,
            name: data.name,
            slug: data.slug,
            link_autorespuesta: data.link_autorespuesta,
            retargeting_sleep: data.retargeting_sleep,
            autorespuesta: data.autorespuesta.length && data.autorespuesta[0],
            retargeting: data.retargeting.length && data.retargeting[0],
        });

        if (editFormConfig) {
            editConfig(data);
        } else {
            toast.success("Configuración guardada");
        }
    };

    const saveInput = (item) => {
        let selected_data = "";
        if (item.type == "select") {
            selected_data = dataSelect;
        }
        setNewInput({
            ...newInput,
            input_id: item.id,
            type: item.type,
            selectedDataArray: selected_data,
            input: item,
            key: Key(),
        });
        setDataSelect([]);
        setRequiredInput(0);
        setErrorMessage(0);
    };

    const resetForm = () => {
        setDataInput("");
        setDataSelect([]);
        setReplyTo(0);
    };

    const saveForm = async () => {
        console.log(formConfig);
        if (
            formConfig.company_id === undefined &&
            formConfig.send_to === undefined
        ) {
            toast.error("Complete la configuración del formulario");
        } else {
            if (dataInput.length === 0) {
                toast.error("Datos Incompletos");
            } else {
                const res = await save(
                    formConfig,
                    dataInput,
                    formConfig.autorespuesta,
                    formConfig.retargeting,
                    resetForm,
                    token
                );
                if (res.success) {
                    toast.success(res.message);
                } else {
                    toast.error(res.message);
                }
            }
        }
    };

    const editConfig = async (config) => {
        const res = await edit_config(config, form, mails, token);
        if (res.success) {
            toast.success(res.message);
        } else {
            toast.error(res.message);
        }
    };

    return (
        <div className="row form">
            <Toaster position="top-left" reverseOrder={false} />
            <div className="col-12">
                <div className=" col-9 mt-3  ">
                    {editableInput && (
                        <EditableInput
                            setEditableInput={setEditableInput}
                            item={itemEditable}
                            dataInput={dataInput}
                            setDataInput={setDataInput}
                            edition={edit}
                            replyTo={replyTo}
                            setReplyTo={setReplyTo}
                        />
                    )}

                    <div className=" col-9 mt-3 ">
                        <Accordion
                            size="sm"
                            defaultActiveKey={["0"]}
                            alwaysOpen
                            className="mb-3"
                            id="accordion"
                        >
                            <AcordionFormConfig
                                handleSubmit={handleSubmit}
                                submitFormConfig={submitFormConfig}
                                errors={errors}
                                register={register}
                                companies={companies}
                                edit={edit}
                                form={form}
                                setEditFormConfig={setEditFormConfig}
                                mails={mails}
                                setMails={setMails}
                            />

                            <AcordionItems
                                inputs={inputs}
                                submit={submit}
                                getChange={getChange}
                                errorMessage={errorMessage}
                                saveInput={saveInput}
                                requiredInput={requiredInput}
                                dataSelect={dataSelect}
                                setDataSelect={setDataSelect}
                                replyTo={replyTo}
                            />
                        </Accordion>
                    </div>

                    {!edit && (
                        <div className="col-9 mt-3 row justify-content-center align-items-center">
                            <div className="d-grid gap-2 col-10 mx-auto">
                                <button
                                    className="btn btn-primary"
                                    type="button"
                                    onClick={() => {
                                        saveForm();
                                    }}
                                >
                                    Guardar
                                </button>
                                <button
                                    className="btn btn-danger"
                                    type="button"
                                    onClick={() => {
                                        resetForm();
                                    }}
                                >
                                    Resetear
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Acordion;
